<div class="spacing" [ngClass]="customSpace ? null : type" [ngStyle]="customSpace ? {height: customSpace + 'px'} : null"></div>
